'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = require('./lib/utils');

exports.default = {
    apollo: '',
    apiRoot: '/api/v1',
    themesLocation: (0, _utils.getParentPathURL)((0, _utils.getScriptURL)()) + 'themes',
    theme: 'default',
    render: {
        desktop: {
            verticalPadding: 0
        },
        mobile: {
            verticalPadding: 0
        }
    },
    validation: {
        trigger: 'change'
    },
    listeners: {
        onRendered: function onRendered(formEl) {
            return null;
        },
        onSubmit: function onSubmit(formData) {
            return true;
        },
        onSuccess: function onSuccess(opts) {
            return null;
        },
        onFailure: function onFailure(errors) {
            return null;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/icarus-forms/module/js/defaults.js
// module id = 211
// module chunks = 2 3